function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++)
      arr2[i] = arr[i];
    return arr2;
  } else {
    return Array.from(arr);
  }
}

(function (d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s);
  js.id = id;
  js.src = "https://connect.facebook.net/nl_NL/sdk.js#xfbml=1&version=v3.0";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");

window.esign = window.esign || {};

esign.cacheSelectors = function () {
  esign.cache = {
    // general
    $html: $("html"),

    // navigation
    $nav: $(".nav-wrap"),
  };
};

esign.init = function () {
  var jsonFetcherWrapper = document.querySelector(".json-fetcher");

  Response.create({
    prop: "width",
    prefix: "min-width- r src",
    breakpoints: [767, 0],
    lazy: true,
  });

  esign.cacheSelectors();

  esign.responsiveVideos();
  esign.blockLink();
  esign.newsletter();
  // esign.newsletterPopup();
  esign.shirtPopup();
  esign.langSelector();
  esign.multiInfoBlock();
  esign.cycle();
  esign.dotdotdot();
  esign.toggleTrigger();
  esign.fancybox();
  esign.anchorJump();
  esign.tooltipster();
  esign.clipboard();
  esign.newsTicker();
  esign.executiveAddPerson();
  esign.sliders();
  esign.modals();
  esign.accordion();
  esign.cookieNotification();
  esign.mainNav();
  esign.countDown();
};

esign.mainNav = function () {
  const mainNavItemEls = document.querySelectorAll(".js-revealing-list");
  [].concat(_toConsumableArray(mainNavItemEls)).forEach(function (item) {
    const mainNavItemContentEl = item.querySelector(".revealing-list");
    if (!mainNavItemContentEl) {
      return;
    }

    const mainNavItemsLinks = mainNavItemContentEl.querySelectorAll("li");
    []
      .concat(_toConsumableArray(mainNavItemsLinks))
      .forEach(function (link, index) {
        link.style.animationDelay = 75 + index * 35 + "ms";
      });

    item.addEventListener("mouseenter", function () {
      mainNavItemContentEl.classList.add("revealing-list--active");
      document.body.classList.add("dark-overlay");
    });

    item.addEventListener("mouseleave", function () {
      mainNavItemContentEl.classList.remove("revealing-list--active");
      document.body.classList.remove("dark-overlay");
    });
  });
};

esign.cookieNotification = function () {
  window.dataLayer = window.dataLayer || [];
  var cookieNotification = document.querySelector(".js-cookie-notification");
  var cookieNotificationTriggers = document.querySelectorAll(
    ".js-cookie-notification__trigger"
  );
  var buttonCookieAll = document.querySelector(".js-cookie-all");
  var buttonCookieReject = document.querySelector(".js-cookie-reject");
  var buttonCookieCustom = document.querySelector(".js-cookie-custom");
  var checkboxAnalytics = document.querySelector(".js-cookie__analytics");
  var checkboxMarketing = document.querySelector(".js-cookie__marketing");

  window.cookieNotification = {};
  window.cookieNotification.cookieSettings = {
    analytics: false,
    marketing: false,
  };

  var gtag = function () {
    dataLayer.push(arguments);
  };

  var triggerDefaultConsent = function () {
    gtag("consent", "default", {
      ad_storage:
        window.cookieNotification.cookieSettings["marketing"] === "true"
          ? "granted"
          : "denied",
      ad_user_data:
        window.cookieNotification.cookieSettings["marketing"] === "true"
          ? "granted"
          : "denied",
      ad_personalization:
        window.cookieNotification.cookieSettings["marketing"] === "true"
          ? "granted"
          : "denied",
      analytics_storage:
        window.cookieNotification.cookieSettings["analytics"] === "true"
          ? "granted"
          : "denied",
    });
  };

  triggerDefaultConsent();

  // Set different cookies
  cookieVariables = ["analytics", "marketing"];
  var updatePreferences = function () {
    for (var i = 0; i < cookieVariables.length; i++) {
      var cookieSetting = cookieVariables[i];
      var cookieName = "cookie_settings__" + cookieSetting;
      var cookieValue = esign.readCookie(cookieName);

      window.cookieNotification.cookieSettings[cookieSetting] =
        cookieValue !== undefined ? cookieValue : false;
    }
  };

  var triggerUpdateConsent = function () {
    gtag("consent", "update", {
      ad_storage:
        window.cookieNotification.cookieSettings["marketing"] === "true"
          ? "granted"
          : "denied",
      ad_user_data:
        window.cookieNotification.cookieSettings["marketing"] === "true"
          ? "granted"
          : "denied",
      ad_personalization:
        window.cookieNotification.cookieSettings["marketing"] === "true"
          ? "granted"
          : "denied",
      analytics_storage:
        window.cookieNotification.cookieSettings["analytics"] === "true"
          ? "granted"
          : "denied",
    });
  };

  var triggerGTMEvent = function () {
    window.dataLayer.push({
      event: "cookieNotification",
    });
  };

  var createCookies = function (cookies) {
    var objectKeys = Object.keys(cookies);
    for (var index = 0; index < objectKeys.length; index++) {
      var key = objectKeys[index];
      var cookieName = "cookie_settings__" + key;
      var value = cookies[key];

      esign.createCookie(cookieName, value, 365);
    }

    cookieNotification.classList.remove("show");
    cookieNotification.classList.add("hide");
    updatePreferences();
    triggerUpdateConsent();
    triggerGTMEvent();
  };

  var showCookieNotification = function () {
    checkboxAnalytics.checked =
      window.cookieNotification.cookieSettings.analytics === "true";
    checkboxMarketing.checked =
      window.cookieNotification.cookieSettings.marketing === "true";

    cookieNotification.classList.remove("hide");
    cookieNotification.classList.add("show");

    buttonCookieAll.addEventListener("click", function () {
      createCookies({ analytics: true, marketing: true });
    });

    buttonCookieReject.addEventListener("click", function () {
      createCookies({ analytics: false, marketing: false });
    });

    buttonCookieCustom.addEventListener("click", function () {
      createCookies({
        analytics: checkboxAnalytics.checked,
        marketing: checkboxMarketing.checked,
      });
    });
  };

  updatePreferences();

  // check cookies
  var showCookie = false;
  for (var j = 0; j < cookieVariables.length; j++) {
    var variable = cookieVariables[j];
    var cookieName = "cookie_settings__" + variable;
    if (!esign.readCookie(cookieName)) {
      showCookie = true;
    }
  }

  if (showCookie) {
    showCookieNotification();
  }

  for (var k = 0; k < cookieNotificationTriggers.length; k++) {
    var trigger = cookieNotificationTriggers[k];
    trigger.addEventListener("click", function () {
      showCookieNotification();
    });
  }

  triggerGTMEvent();

  // check form
  var form = document.querySelector(".cookie-notification__form");
  var toggleForm = document.querySelectorAll(".js-toggle-cookie-form");
  for (var l = 0; l < toggleForm.length; l++) {
    var trigger = toggleForm[l];
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      form.classList.toggle("show");
    });
  }
};

esign.createCookie = function (name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
  } else var expires = "";

  document.cookie = name + "=" + value + expires + "; path=/";
};

esign.readCookie = function (name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
};

esign.fbshare = function () {};

esign.accordion = function accordion(el) {
  var slideUp = function slideUp(element) {
    var duration =
      arguments.length <= 1 || arguments[1] === undefined ? 500 : arguments[1];

    return new Promise(function (resolve, reject) {
      element.style.height = element.offsetHeight + "px";
      element.style.transitionProperty = "height, margin, padding";
      element.style.transitionDuration = duration + "ms";
      element.offsetHeight;
      element.style.overflow = "hidden";
      element.style.height = 0;
      element.style.paddingTop = 0;
      element.style.paddingBottom = 0;
      element.style.marginTop = 0;
      element.style.marginBottom = 0;
      element.parentNode.classList.remove("--open", "active");
      element.parentNode
        .querySelector(".js-accordion__trigger")
        .classList.remove("accordion--open");
      window.setTimeout(function () {
        element.style.display = "none";
        element.style.removeProperty("height");
        element.style.removeProperty("padding-top");
        element.style.removeProperty("padding-bottom");
        element.style.removeProperty("margin-top");
        element.style.removeProperty("margin-bottom");
        element.style.removeProperty("overflow");
        element.style.removeProperty("transition-duration");
        element.style.removeProperty("transition-property");
        resolve(false);
      }, duration);
    });
  };

  /**
   * SlideDown
   *
   * @param {HTMLElement} element
   * @param {Number} duration
   * @returns {Promise<boolean>}
   */
  var slideDown = function slideDown(element) {
    var duration =
      arguments.length <= 1 || arguments[1] === undefined ? 500 : arguments[1];

    return new Promise(function (resolve, reject) {
      element.style.removeProperty("display");
      var display = window.getComputedStyle(element).display;

      if (display === "none") display = "block";

      element.style.display = display;
      var height = element.offsetHeight;
      element.style.overflow = "hidden";
      element.style.height = 0;
      element.style.paddingTop = 0;
      element.style.paddingBottom = 0;
      element.style.marginTop = 0;
      element.style.marginBottom = 0;
      element.offsetHeight;
      element.style.transitionProperty = "height, margin, padding";
      element.style.transitionDuration = duration + "ms";
      element.style.height = height + "px";
      element.parentNode.classList.add("--open", "active");
      element.parentNode
        .querySelector(".js-accordion__trigger")
        .classList.add("accordion--open");
      element.style.removeProperty("padding-top");
      element.style.removeProperty("padding-bottom");
      element.style.removeProperty("margin-top");
      element.style.removeProperty("margin-bottom");

      window.setTimeout(function () {
        element.style.removeProperty("height");
        element.style.removeProperty("overflow");
        element.style.removeProperty("transition-duration");
        element.style.removeProperty("transition-property");
      }, duration);
    });
  };

  /**
   * SlideToggle
   *
   * @param {HTMLElement} element
   * @param {Number} duration
   * @returns {Promise<boolean>}
   */
  var slideToggle = function slideToggle(element) {
    var duration =
      arguments.length <= 1 || arguments[1] === undefined ? 350 : arguments[1];

    if (window.getComputedStyle(element).display === "none") {
      return slideDown(element, duration);
    } else {
      return slideUp(element, duration);
    }
  };

  function togglePanel(panel) {
    slideToggle(panel);
  }

  function addEvents(trigger, panel) {
    trigger.addEventListener("click", function (e) {
      if (
        trigger.getAttribute("href") &&
        e.target.tagName.toLowerCase() !== "a"
      ) {
        e.preventDefault();
        trigger.setAttribute(
          "aria-expanded",
          trigger.getAttribute("aria-expanded") === "false"
        );
        togglePanel(panel);
      } else if (!trigger.getAttribute("href")) {
        trigger.setAttribute(
          "aria-expanded",
          trigger.getAttribute("aria-expanded") === "false"
        );
        togglePanel(panel);
      }
    });
  }

  function open(el) {
    var panel = el || panel;
    slideDown(panel);
  }

  function close(el) {
    var panel = el || panel;
    slideUp(panel);
  }

  function checkParent() {
    var parent = el.parentNode.closest(".js-accordion");
    if (parent) {
      var trigger = parent.querySelector(".js-accordion__trigger");
      var panel = parent.querySelector(".js-accordion__panel");
      trigger.setAttribute(
        "aria-expanded",
        trigger.getAttribute("aria-expanded") === "false"
      );
      open(panel);
    }
  }

  function checkUrl(id) {
    if (window.location.href.indexOf("#" + id) > -1) {
      checkParent();
      open();
      var headerOffset = document
        .querySelector(".js-header")
        .getBoundingClientRect().height;
      var topOffset = trigger.getBoundingClientRect().top - headerOffset - 30;

      window.scrollTo({ top: topOffset, behavior: "smooth" });
    }
  }

  function init(el) {
    var trigger = el.querySelector(".js-accordion__trigger");
    var panel = el.querySelector(".js-accordion__panel");
    var id = el.id || false;

    addEvents(trigger, panel);

    if (id) {
      checkUrl(id);
    }
  }

  var accordionEls = document.querySelectorAll(".js-accordion");
  [].concat(_toConsumableArray(accordionEls)).forEach(function (a) {
    return init(a);
  });
};

esign.responsiveVideos = function () {
  $(
    'iframe[src*="youtube.com/embed"], iframe[src*="youtube-nocookie.com/embed"], iframe[src*="player.vimeo"], .rte video'
  ).wrap('<div class="video-container"></div>');
};

esign.blockLink = function () {
  $(".blocklink").click(function (e) {
    e.preventDefault();
    var url = $(this).find(".target").attr("href");
    window.location = url;
  });
};

/* ajax newsletter subscribe */
esign.newsletter = function () {
  $(".form-newsletter").submit(function (e) {
    $form = $(this);

    $.post($form.attr("action"), $form.serializeArray(), function (data) {
      if (data.errors === false) {
        $form.html(data.result);
      } else {
        $form.find(".result").html(data.result);
      }
    });

    e.preventDefault();
    return false;
  });
};

esign.newsletterPopup = function () {
  function createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  if (!readCookie("newsletter-popup")) {
    if (typeof $.fancybox == "function") {
      var newsletterPopup = $(".fancybox-newsletter").fancybox({
        openEffect: "fade",
        closeEffect: "none",
        loop: false,
        padding: 0,
        helpers: {
          overlay: {
            locked: false,
          },
        },
        type: "inline",
        tpl: {
          closeBtn:
            '<a title="Sluiten" class="fancybox-item fancybox-close hidden" href="javascript:;"></a>',
          error:
            '<p class="fancybox-error">De gevraagde inhoud kan niet worden.<br/>Probeer later opnieuw.</p>',
          next: '<a title="Volgende" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
          prev: '<a title="Vorige" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
        },
        afterShow: function () {
          createCookie("newsletter-popup", "true", 30);
        },
      });
    }

    setTimeout(function () {
      $("#newsletter-popup-trigger").click();
    }, 3000);
  }
};

esign.shirtPopup = function () {
  function createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  function createSpecificCookie(name, value, customDate) {
    if (customDate) {
      var expires = "; expires=" + new Date(customDate);
    } else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  // if (new Date() <= new Date("2022-06-18T08:00:00.000Z")) {
  //   createSpecificCookie("new-shirt-popup", "true", "2022-06-17T08:00:00.000Z");
  // }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  if (
    new Date() > new Date("2022-06-18T08:00:00.000Z") &&
    !readCookie("new-shirt-popup")
  ) {
    if (typeof $.fancybox == "function") {
      var newShirtPopup = $(".fancybox-shirt").fancybox({
        openEffect: "fade",
        closeEffect: "none",
        loop: false,
        padding: 0,
        helpers: {
          overlay: {
            locked: false,
          },
        },
        type: "inline",
        tpl: {
          closeBtn:
            '<a title="Sluiten" class="fancybox-item fancybox-close hidden" href="javascript:;"></a>',
          error:
            '<p class="fancybox-error">De gevraagde inhoud kan niet worden.<br/>Probeer later opnieuw.</p>',
          next: '<a title="Volgende" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
          prev: '<a title="Vorige" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
        },
        afterShow: function () {
          createCookie("new-shirt-popup", "true", "300");
        },
      });
    }

    setTimeout(function () {
      $("#shirt-popup-trigger").click();
    }, 3000);
  }
};

esign.langSelector = function () {
  $(".lang-trigger").click(function () {
    var $langWrapper = $(this).parents(".lang-selector");
    $langWrapper.find(".lang-list").slideToggle(100);
  });
};

esign.multiInfoBlock = function () {
  $(".multi-info-block .tabs a").click(function () {
    var $clickedTab = $(this).data("info");

    $(".multi-info-block .tabs li").removeClass("active");
    $(this).parents("li").addClass("active");

    var $activeInfoBlock = $(".multi-info-block--mobile").find(
      "#" + $clickedTab
    );

    $(".info-block").removeClass("active");
    $activeInfoBlock.addClass("active");
  });
};

esign.cycle = function () {
  if (Modernizr.touch) {
    $(".cycle-slideshow").each(function (index) {
      $(this).swipe({
        swipe: function (event, direction) {
          if (direction === "left" || direction === "up") {
            $(this).cycle("next");
          } else {
            $(this).cycle("prev");
          }
        },
        allowPageScroll: "vertical",
      });
    });
  }
};

esign.dotdotdot = function () {
  $(".dotdotdot").dotdotdot({
    watch: false,
  });

  $(".dotdotdot").addClass("visible");
};

esign.toggleTrigger = function () {
  $(".toggle-trigger").click(function () {
    $wrapper = $(this).parents(".toggle-wrapper");
    $wrapper.find(".toggle-content").slideToggle();

    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      var content = $(this).data("pos");
      $(this).html(content);
    } else {
      $(this).addClass("open");
      var content = $(this).data("neg");
      $(this).html(content);
    }
  });

  //other static toggles
  var os = getMobileOperatingSystem();

  if (os == "Android" || os == "Unknown") {
    $(".type-android").show();
    $("#android-toggle-trigger").click(function () {
      $("#android-toggle-content").slideToggle();
    });
  } else {
    //ios or windows
    $(".type-ios").show();
    $("#ios-toggle-trigger").click(function () {
      $("#ios-toggle-content").slideToggle();
    });
  }
};

esign.fancybox = function () {
  if (typeof $.fancybox == "function") {
    $(".fancybox").fancybox({
      openEffect: "elastic",
      closeEffect: "none",
      loop: false,
      padding: 0,
      helpers: {
        overlay: {
          locked: false,
        },
      },
      type: "image",
      afterShow: function () {
        if ("ontouchstart" in document.documentElement) {
          $(".fancybox-nav").css("display", "none");
          $(".fancybox-wrap").swipe({
            swipe: function (event, direction) {
              if (direction === "left" || direction === "up") {
                $.fancybox.next();
              } else {
                $.fancybox.prev();
              }
            },
          });
        }
      },
      tpl: {
        closeBtn:
          '<a title="Sluiten" class="fancybox-item fancybox-close" href="javascript:;"></a>',
        error:
          '<p class="fancybox-error">De gevraagde inhoud kan niet worden.<br/>Probeer later opnieuw.</p>',
        next: '<a title="Volgende" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
        prev: '<a title="Vorige" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
      },
    });
  }

  if (typeof $.fancybox == "function") {
    $(".fancybox-iframe").fancybox({
      openEffect: "elastic",
      closeEffect: "none",
      loop: false,
      padding: 0,
      helpers: {
        overlay: {
          locked: false,
        },
      },
      type: "iframe",
      afterShow: function () {
        if ("ontouchstart" in document.documentElement) {
          $(".fancybox-nav").css("display", "none");
          $(".fancybox-wrap").swipe({
            swipe: function (event, direction) {
              if (direction === "left" || direction === "up") {
                $.fancybox.next();
              } else {
                $.fancybox.prev();
              }
            },
          });
        }
      },
      tpl: {
        closeBtn:
          '<a title="Sluiten" class="fancybox-item fancybox-close" href="javascript:;"></a>',
        error:
          '<p class="fancybox-error">De gevraagde inhoud kan niet worden.<br/>Probeer later opnieuw.</p>',
        next: '<a title="Volgende" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
        prev: '<a title="Vorige" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
      },
    });
  }

  if (typeof $.fancybox == "function") {
    $(".fancybox-inline").fancybox({
      openEffect: "elastic",
      closeEffect: "none",
      loop: false,
      padding: 0,
      helpers: {
        overlay: {
          locked: false,
        },
      },
      type: "inline",
      afterShow: function () {
        if ("ontouchstart" in document.documentElement) {
          $(".fancybox-nav").css("display", "none");
          $(".fancybox-wrap").swipe({
            swipe: function (event, direction) {
              if (direction === "left" || direction === "up") {
                $.fancybox.next();
              } else {
                $.fancybox.prev();
              }
            },
          });
        }
      },
      tpl: {
        closeBtn:
          '<a title="Sluiten" class="fancybox-item fancybox-close" href="javascript:;"></a>',
        error:
          '<p class="fancybox-error">De gevraagde inhoud kan niet worden.<br/>Probeer later opnieuw.</p>',
        next: '<a title="Volgende" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
        prev: '<a title="Vorige" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
      },
    });
  }
};

esign.anchorJump = function () {
  var jump = function ($elt) {
    var offset = 50;
    window.scrollTo(0, $elt.offset().top - $("header").outerHeight() - offset);
  };

  $(window).on("hashchange", function () {
    var $elt = $(location.hash);
    if (location.hash !== "#member-modal") {
      jump($elt);
    }
  });

  $(window).load(function () {
    if (location.hash) {
      if (location.hash !== "#member-modal") {
        setTimeout(function () {
          var $anchor = $(location.hash);
          jump($anchor);
        }, 0);
      }
    }
  });
};

esign.tooltipster = function () {
  $(".tooltip").tooltipster();
};

esign.clipboard = function () {
  new Clipboard(".button-clipboard");
};

function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}

esign.newsTicker = function () {
  var newsTicker = $(".news-ticker");
  var newsTickerContent = $(".news-ticker ul");

  if (newsTickerContent.width() < newsTicker.width()) {
    var ratio = newsTicker.width() / newsTickerContent.width();
    ratio = Math.ceil(ratio);
    for (var i = 0; i < ratio; i++) {
      var newsTickerList = $(".news-ticker ul:last-child").clone();
      newsTicker.append(newsTickerList);
    }
  }

  var tickrSpeed = 50;
  if ($(window).width() < 1400) {
    tickrSpeed = 40;
  }
  if ($(window).width() < 768) {
    tickrSpeed = 30;
  }

  $(".news-ticker").marquee({
    duration: 0,
    speed: 50,
    delayBeforeStart: 0,
    direction: "left",
    duplicated: true,
    pauseOnHover: true,
    startVisible: true,
  });
};

esign.sliders = function () {
  const sliderIntroThumbsEl = document.querySelector(".js-slider-intro-thumbs");
  const sliderIntroEl = document.querySelector(".js-slider-intro");

  if (sliderIntroThumbsEl && sliderIntroEl) {
    const thumbsOptions = {
      direction: "horizontal",
      loop: false,
      watchOverflow: true,
      slidesPerView: 1,
      watchSlidesProgress: true,
      spaceBetween: 10,
      effect: "fade",
      waitForTransition: true,
      clickable: false,
      breakpoints: {
        768: {
          slidesPerView: 3,
          effect: false,
          spaceBetween: 10,
        },
      },
    };

    const sliderIntroThumbInstance = new Swiper(
      sliderIntroThumbsEl,
      thumbsOptions
    );

    const slidesCount = document.querySelector(".js-slider-intro swiper-slide");
    const options = {
      direction: "horizontal",
      loop: slidesCount > 1,
      watchOverflow: true,
      slidesPerView: 1,
      loop: true,
      speed: 800,
      effect: "fade",
      autoplay: {
        delay: 6000,
      },
      thumbs: {
        swiper: sliderIntroThumbInstance,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: "false",
        type: "bullets",
        renderBullet: function (index, className) {
          return (
            '<span class="' +
            className +
            '">' +
            "<em>" +
            "</em>" +
            "<i></i>" +
            "<b></b>" +
            "</span>"
          );
        },
      },
      breakpoints: {
        768: {
          pagination: false,
        },
      },
    };

    const sliderIntroInstance = new Swiper(sliderIntroEl, options);

    sliderIntroThumbsEl
      .querySelectorAll(".swiper-slide")
      .forEach(function (slide) {
        slide.addEventListener("mouseover", function () {
          var index = Array.prototype.indexOf.call(
            slide.parentNode.children,
            slide
          );
          sliderIntroInstance.slideToLoop(index, 800);
        });
      });
  }

  if (document.querySelector(".js-slider-games")) {
    const prevArrow = document.querySelector(
      ".js-games-navigation .js-slider-prev"
    );
    var gamesSlider = new Swiper(".js-slider-games", {
      direction: "horizontal",
      loop: false,
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 15,
      initialSlide: "1",
      allowSlidePrev: true,
      navigation: {
        prevEl: document.querySelector(".js-games-navigation .js-slider-prev"),
        nextEl: document.querySelector(".js-games-navigation .js-slider-next"),
      },
      pagination: {
        el: ".js-slider-games-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1400: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
        1600: {
          slidesPerView: 3,
        },
      },
      on: {
        slideChange: function () {
          const activeIndex = this.activeIndex;
          if (this.params.slidesPerView == "auto") {
            if (activeIndex < 2) {
              prevArrow.classList.add("disabled");
              this.allowSlidePrev = false;
            } else {
              prevArrow.classList.remove("disabled");
              this.allowSlidePrev = true;
            }
          }
        },
      },
    });
  }
  if (document.querySelector(".js-slider-videos")) {
    var videoSlider = new Swiper(".js-slider-videos", {
      direction: "horizontal",
      loop: true,
      slidesPerView: 1.3,
      spaceBetween: 30,
      navigation: {
        prevEl: document.querySelector(".js-video-navigation .js-slider-prev"),
        nextEl: document.querySelector(".js-video-navigation .js-slider-next"),
      },
      breakpoints: {
        640: {
          slidesPerView: 2.5,
        },
        1680: {
          slidesPerView: 3,
        },
      },
    });
  }
  if (document.querySelector(".js-slider-in-the-picture")) {
    var inThePictureSlider = new Swiper(".js-slider-in-the-picture", {
      direction: "horizontal",
      centeredSlides: false,
      preloadImages: true,
      updateOnImagesReady: true,
      slidesPerView: "auto",
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      spaceBetween: 0,
      loop: false,
      initialSlide: 0,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      navigation: {
        prevEl: document.querySelector(
          ".js-in-the-picture-navigation .js-slider-prev"
        ),
        nextEl: document.querySelector(
          ".js-in-the-picture-navigation .js-slider-next"
        ),
      },
    });
  }
  if (document.querySelector(".js-slider-products")) {
    var productlider = new Swiper(".js-slider-products", {
      direction: "horizontal",
      loop: true,
      slidesPerView: 1.5,
      spaceBetween: 30,
      navigation: {
        prevEl: document.querySelector(
          ".js-products-navigation .js-slider-prev"
        ),
        nextEl: document.querySelector(
          ".js-products-navigation .js-slider-next"
        ),
      },
      breakpoints: {
        640: {
          slidesPerView: 2.5,
        },
        1024: {
          slidesPerView: 3,
        },
        1600: {
          slidesPerView: 4,
        },
      },
    });
  }
};

esign.modals = function () {
  $(".trigger").modaal({
    fullscreen: true,
    content_source: "#mobile-nav",
  });

  $(".js-calendar-trigger").modaal();

  const modalTrigger = document.querySelector(".js-open-modal");
  if (modalTrigger && !window.authenticated) {
    modalTrigger.addEventListener("click", function (event) {
      event.preventDefault();
    });
    $(".js-open-modal").modaal({
      content_source: "#member-modal",
      custom_class: "member-modal",
    });
  }
};

//TODO make menu responsive without refresh
//does not work
$(window).resize(function () {
  //headroom
  //esign.headroom();

  //dotdotdot
  $(".dotdotdot").trigger("update");
});

esign.countDown = function () {
  const el = document.querySelector(".js-next-game-countdown");
  let countdownWrapper, countdownDate;
  if (el) {
    countdownWrapper = el.querySelector("#countdown");
    countDownDate = new Date(el.dataset.time).getTime();
  }

  if (el && countdownWrapper && countDownDate) {
    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the element
      countdownWrapper.innerHTML = `<span>${days}</span>D <span>${hours}</span>U <span>${minutes}</span>M <span>${seconds}</span>S`;

      // Make sure that countdown is visible
      el.classList.remove("hide");

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        countdownWrapper.innerHTML = "___";
      }
    }, 1000);
  }
};

esign.executiveAddPerson = function () {
  var persMax = $(".extra-persons").data("max");
  var currPers = 0;

  $(".extra-persons .holder .form-element").each(function (index) {
    currPers = currPers + 1;
  });

  $(".add-extra-person").click(function () {
    if (currPers < persMax) {
      var $template = $("#template-person").clone().removeAttr("id");
      $(".extra-persons .holder").append($template);
      currPers = currPers + 1;
      checkForButtons();
    }
  });

  $("body").on("click", ".remove-extra-person", function () {
    $(this).closest(".form-element").remove();
    currPers = currPers - 1;
    checkForButtons();
  });

  if ($("#check-extra-persons").is(":checked")) {
    $(".extra-persons").show();
  }

  $("#check-extra-persons").change(function () {
    if (this.checked) {
      $(".extra-persons").show();
    } else {
      $(".extra-persons").hide();
    }
  });

  // Hide extra fields when participant is not attending
  if ($(".js-dinner-choice-div input:checked").length != 0) {
    var answerRadio = $(".js-dinner-choice-div input:checked")[0].value;
    if (answerRadio.indexOf("wont-come") !== -1) {
      $(".js-extra-info").addClass("hidden");
    } else {
      $(".js-extra-info").removeClass("hidden");
    }
  }

  $(".js-dinner-choice-div input").change(function () {
    var answer = this.value;
    if (answer.indexOf("wont-come") !== -1) {
      $(".js-extra-info").addClass("hidden");
    } else {
      $(".js-extra-info").removeClass("hidden");
    }
  });

  checkForButtons();

  function checkForButtons() {
    if (currPers < persMax) {
      $(".add-extra-person").show();
    }

    if (currPers == persMax) {
      $(".add-extra-person").hide();
    }
  }
};

// initialize on docready
$(esign.init);
//# sourceMappingURL=esign.js.map

//# sourceMappingURL=esign.js.map
